import { toaster } from '../../../components/ui/toaster';
import { useAppDispatch, useAppSelector } from '../../../lib/hooks';
import { getDefaultGraphView } from '../../../lib/GraphFactory';
import {
  // addDocumentResult,
  setDocumentStructure,
} from '../../../lib/state/slices/ProjectStateSlice';
import { useSigma } from '@react-sigma/core';
import { useEffect, useState } from 'react';
import { Circle, Folder as FolderIcon, Maximize2, Save } from 'react-feather';
import { AISparcles } from '../../../components/Icons';
import ContextMenu, { ContextMenuButton } from '../../../components/ContextMenu';
import { Folder } from '../../../lib/state/ViewTypes';
import { Node } from '../../../lib/api/APITypes';

export default function NodeContextMenu(props: {
  id: string;
  nodeId: string;
  loadNeighbours: (id: string) => void;
  recommendNeighbours: (id: string, nodeId: string) => void;
}) {
  const dispatch = useAppDispatch();
  const folders = useAppSelector((state) => state.viewReducer.documents.structure.FOLDER);
  const graph = useSigma().getGraph();

  let sigma = useSigma();
  const [position, setPosition] = useState(() => {
    let attributes = sigma.getGraph().getNodeAttributes(props.nodeId);
    let viewportPosition = sigma.graphToViewport({ x: attributes.x, y: attributes.y });
    viewportPosition.x = viewportPosition.x - 200;
    viewportPosition.y = viewportPosition.y + 10;
    return viewportPosition;
  });
  useEffect(() => {
    sigma.on('afterRender', () => {
      let attributes = sigma.getGraph().getNodeAttributes(props.nodeId);
      let viewportPosition = sigma.graphToViewport({ x: attributes.x, y: attributes.y });
      viewportPosition.x = viewportPosition.x - 200;
      viewportPosition.y = viewportPosition.y + 10;
      setPosition(viewportPosition);
    });
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        top: position.y,
        left: position.x,
      }}
    >
      <ContextMenu onClose={() => {}}>
        <ContextMenuButton
          icon={Circle}
          text="New Center"
          onClick={() => {
            let newGraphView = getDefaultGraphView(props.id);
            newGraphView.name = graph
              .getNodeAttribute(props.nodeId, 'label')
              .replace('CASE OF', '')
              .trim();

            // dispatch(addNewGraphView(newGraphView));

            dispatch(
              setDocumentStructure({
                type: 'GRAPH',
                key: newGraphView.id,
                value: newGraphView,
              }),
            );

            toaster.create({
              title: 'Graph opened',
              description: 'Your Graph has been opened in the sidebar',
              type: 'info',
              duration: 3000,
              closable: true,
            });
          }}
        />
        <ContextMenuButton
          icon={Maximize2}
          text="Expand Neighbours"
          onClick={() => {
            props.loadNeighbours(props.id);
            toaster.create({
              title: 'Neigbours loaded',
              description: 'The new neighbours might not be visible due to filters',
              type: 'info',
              duration: 3000,
              closable: true,
            });
          }}
        />
        <ContextMenuButton
          icon={AISparcles}
          text="Recommend Neighbours"
          onClick={() => {
            props.recommendNeighbours(props.id, props.nodeId);
            toaster.create({
              title: 'Neigbours recommended',
              description: 'The new neighbours might not be visible due to filters',
              type: 'info',
              duration: 3000,
              closable: true,
            });
          }}
        />
        <ContextMenuButton
          icon={Save}
          text="Save to Folder"
          onClick={() => {}}
          submenu={
            <ContextMenu onClose={() => {}}>
              {Object.values(folders)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((folder, index) => (
                  <ContextMenuButton
                    key={folder.id}
                    icon={FolderIcon}
                    text={folder.name}
                    onClick={() => {
                      // folder.documents =
                      // dispatch(addSearchResult({ type: "FOLDER", result:  })
                      const folderID = folder.name.toLowerCase();
                      const smt: Folder = {
                        id: folder.id,
                        name: folderID,
                        documents: [...folder.documents, props.id],
                      };

                      const node: Node = sigma.getGraph().getNodeAttributes(props.nodeId) as Node;

                      dispatch(
                        setDocumentStructure({ type: 'FOLDER', key: folder.id, value: smt }),
                      );
                      // dispatch(addDocumentResult({ type: 'SAVED', value: node }));
                      // // dispatch
                      // // dispatch(saveDoc({ folderId: folder.id, nodeId: props.id }));
                      // toaster.create({
                      //   title: 'Document saved',
                      //   description: 'The document has been saved to ' + folder.name,
                      //   type: 'info',
                      //   duration: 3000,
                      //   closable: true,
                      // });
                    }}
                  />
                ))}
              {/* {folders
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((folder, index) => (
                  <ContextMenuButton
                    key={folder.id}
                    icon={FolderIcon}
                    text={folder.name}
                    onClick={() => {
                      // folder.documents =
                      // dispatch(addSearchResult({ type: "FOLDER", result:  })
                      const folderID = folder.name.toLowerCase();
                      const smt: Folder = {
                        id: folder.id,
                        name: folderID,
                        documents: [...folder.documents, props.id],
                      };
                      dispatch(setDocumentStructure({ type: "FOLDER", key: folder.id, value: smt }))
                      dispatch(saveDoc({ folderId: folder.id, nodeId: props.id }));
                      toaster.create({
                        title: 'Document saved',
                        description: 'The document has been saved to ' + folder.name,
                        status: 'info',
                        duration: 3000,
                        isClosable: true,
                      });
                    }}
                  />
                ))} */}
            </ContextMenu>
          }
        />
      </ContextMenu>
    </div>
  );
}
